import React from 'react'
import { useParams, useLocation } from 'react-router-dom'
import Banners from '../../../GlobalComponents/User/Banners'
import LevelCommissionMobile from './LevelCommissionMobile'

const LevelCommission = () => {
	const { level } = useParams()
	const location = useLocation()
	const users = location.state?.users || []

	return (
		<div>
			<div className='main-width display'>
				<Banners />
				<div className='row d-flex w-auto justify-content-center'>
					<div className='col-lg-11'>
						<div className='card w-100 card-body mt-n7'>
							<h2 className='source-serif-4 text-normal text-dark'>
								<i className='ri-team-line class-name mx-md-2 text-dark ' aria-hidden='true'></i>
								Level No - {level}
							</h2>
							<div className='card w-100 text-center mx-auto p-2 mt-3 mb-3 bg-gold-light'>
								<div className='table-responsive border-radius-2xl'>
									<table className='table align-items-center mb-0'>
										<thead>
											<tr>
												<th className='text-uppercase text-dark text-md font-weight-bold'>S.NO</th>
												<th className='text-uppercase text-dark text-md font-weight-bold'>LEVEL No</th>
												<th className='text-uppercase text-dark text-md font-weight-bold'>User Id</th>
												<th className='text-uppercase text-dark text-md font-weight-bold'>Upliner Id</th>

												<th className='text-uppercase text-dark text-md font-weight-bold'>Referral Commissions</th>
											</tr>
										</thead>
										<tbody className='bg-white'>
											{users.map((user, index) => (
												<tr key={user._id}>
													<td className='text-dark text-md font-weight-normal'>{index + 1}</td>
													<td className='text-dark text-md font-weight-normal'>{level}</td>
													<td className='text-dark text-md font-weight-normal'>{user.registerId}</td>
													<td className='text-dark text-md font-weight-normal'>{user?.mainUser?.registerId}</td>

													<td className='text-dark text-md font-weight-normal'>
														<sup>₹</sup>
														{Number(user.commissionAmount || 0).toFixed(2)}
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className='display-full'>
				<LevelCommissionMobile />
			</div>
		</div>
	)
}

export default LevelCommission
